import { useState, useEffect } from 'react';
import { api } from '../utils/api';

export const useFetchWithCache = (url, initialData = null) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const reload = () => setRefreshKey(prev => prev + 1);

  useEffect(() => {
    if (!url) return;
    let mounted = true;

    const fetchData = async () => {
      try {
        const cachedData = await api.getCached(url);
        if (mounted && cachedData) {
          setData(cachedData);
          setLoading(false);
        }
        const freshData = await api.get(url);
        if (mounted) {
          setData(freshData);
          setLoading(false);
          await api.setCache(url, freshData);
        }
      } catch (err) {
        if (mounted) {
          console.error(`Error fetching ${url}:`, err);
          setError(err.message);
          setLoading(false);
        }
      }
    };

    fetchData();
    return () => { mounted = false; };
  }, [url, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, reload };
};
